exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .content {\n  max-width: 1100px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/user-complaints/complaints-list/complaints-list.component.scss
// module id = ../../../../../src/app/main/content/user-complaints/complaints-list/complaints-list.component.scss
// module chunks = main